var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import styles from './Alert.module.scss';
import { Success, Warning, Danger } from '../../assets/icons';
var Alert = function (_a) {
    var text = _a.text, warning = _a.warning, danger = _a.danger, className = _a.className, id = _a.id, dataId = _a.dataId;
    var classes = "".concat(warning ? styles.Warning : '', " ").concat(danger ? styles.Danger : '');
    var renderIcon = function () {
        if (warning)
            return _jsx(Warning, {});
        if (danger)
            return _jsx(Danger, {});
        return _jsx(Success, {});
    };
    return (_jsxs("div", __assign({ id: id, className: "".concat(styles.Alert, " ").concat(classes, " ").concat(className ? className : ''), "data-testid": dataId }, { children: [_jsx("i", __assign({ className: styles.Icon }, { children: renderIcon() })), text] })));
};
Alert.propTypes = {
    text: PropTypes.string.isRequired,
    warning: PropTypes.bool,
    danger: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
    dataId: PropTypes.string,
};
Alert.defaultProps = {
    className: '',
};
export { Alert };
//# sourceMappingURL=Alert.js.map